import http from "./http-common";

class apiservice {

  login(data) {  //로그인
    return http.post(`/api/login.php`, data);
  }
  memberlist(data) {  //학생 리스트 추출
    return http.get(`/api/memberlist.php`, data);
  }  
  getdeptlist(data) {  //부서 정보 추출
    return http.get(`/api/GetDeptList.php`, data);
  }  
  getclasslist(data) {  // 학급 반 정보 추출
    return http.post(`/api/GetClassList.php`, data);
  }    
  getsunday() {  // 주일 날짜 추출
    return http.post(`/api/GetSunday.php`);
  } 
  attendlist(data) {  // 학급 반 정보 추출
    return http.post(`/api/AttendList.php`, data);
  }   
  teacherlist(data) {  //선생님 리스트 추출
    return http.post(`/api/teacherlist.php`, data);
  } 
  update_teacher(data) { // 선생님 정보 업데이트
    return http.post(`/api/update_teacher.php`, data);
  }
  get_grades_by_dept(data) { // 부서별 반(grade) 목록
    return http.post(`/api/get_grades_by_dept.php`, data);
  }
  fetchAttendanceStatistics(data) {  //dashboard 
    return http.post(`/api/Dashboard.php`, data);
  } 
  updatemember(data) {  // 학생 정보 업데이트
    return http.post(`/api/updatemember.php`, data);
  }

  // 학생 추가 정보 조회/저장
  getmemberextra(data) { // 학생 부가정보 조회
    return http.post(`/api/getmemberextra.php`, data);
  }
  updatememberextra(data) { // 학생 부가정보 저장
    return http.post(`/api/updatememberextra.php`, data);
  }
  getstudentsummary(data) { // 학생 종합정보 리스트
    return http.post(`/api/getstudentsummary.php`, data);
  }

  post(url, data) {
    return http.post(`${this.API_URL}${url}`, data);
  }
  attendgrid(data) {  //출석 그리드
    return http.post(`/api/attendgrid.php`, data);
  } 
  attendweekly(data) {  //출석 그리드
    return http.post(`/api/attendweekly.php`, data);
  } 
  // temp teacher migration
  teachertemp_list(data) {
    return http.post(`/api/teacher_temp_list.php`, data);
  }
  teachertemp_update(data) {
    return http.post(`/api/teacher_temp_update.php`, data);
  }
  teachertemp_create(data) {
    return http.post(`/api/teacher_temp_create.php`, data);
  }
  teachertemp_delete(data) {
    return http.post(`/api/teacher_temp_delete.php`, data);
  }
  get_temp_classlist(data) {
    return http.post(`/api/get_temp_classlist.php`, data);
  }
  get_teachers_by_class_grade(data) {
    return http.post(`/api/get_teachers_by_class_grade.php`, data);
  }
  classInfoList(data) {
    return http.post(`/api/class_info_list.php`, data);
  }
  classInfoCreate(data) {
    return http.post(`/api/class_info_create.php`, data);
  }
  classInfoUpdate(data) {
    return http.post(`/api/class_info_update.php`, data);
  }
  classInfoBulkUpsert(data) {
    return http.post(`/api/class_info_bulk_upsert.php`, data, { timeout: 120000 });
  }
  getClassManageTeachers(data) {
    return http.post(`/api/get_class_manage_teachers.php`, data);
  }
  // student temp manage
  studenttemp_list(data) {
    return http.post(`/api/student_temp_list.php`, data);
  }
  studenttemp_update(data) {
    return http.post(`/api/student_temp_update.php`, data);
  }
  studenttemp_create(data) {
    return http.post(`/api/student_temp_create.php`, data);
  }
  studenttemp_delete(data) {
    return http.post(`/api/student_temp_delete.php`, data);
  }
  get_temp_teachers(data) {
    return http.post(`/api/get_temp_teachers.php`, data);
  }
}

export default new apiservice();
